import { createRouter } from "@tanstack/react-router";

// Import the generated route tree
import NotFoundPage from "./components/NotFoundPage";
import { routeTree } from "./routeTree.gen";

import { initClarity } from "./lib/clarity";
import { getConsentStatus } from "./lib/cookieConsent";
import { initPinterest } from "./lib/pinterest";
import { initSentry } from "./lib/sentry";

// Create a new router instance
export const getRouter = () => {
  const router = createRouter({
    context: {},
    defaultNotFoundComponent: NotFoundPage,
    defaultPreloadStaleTime: 0,
    routeTree,
    scrollRestoration: true,
  });

  if (!router.isServer && getConsentStatus() === "accepted") {
    initSentry();
    initClarity();
    initPinterest();
  }

  return router;
};
